import React, { useState } from 'react';
import { Container, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaMoneyBill, FaEdit, FaTrashAlt} from 'react-icons/fa';
import '../../Styles/yellocalfcss/CollectRegistrationFee.css';

const CollectRegistrationFee = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [filters, setFilters] = useState({ invoiceId: '', student: '', rfid: '', email: '' });
  const [currentPage, setCurrentPage] = useState(1);

  const invoicesPerPage = 15;

  const invoices = [
    { id: 1785, student: 'Ashutosh', year: '2020-2021', demandDate: '2024-06-10', dueDate: '2024-06-10', amountTotal: 3700, amountPaid: 0, balance: 3700, status: 'Pending' },
    { id: 1786, student: 'John Doe', year: '2020-2021', demandDate: '2024-06-10', dueDate: '2024-06-10', amountTotal: 3800, amountPaid: 0, balance: 3800, status: 'Pending' },
    { id: 1787, student: 'Jane Smith', year: '2021-2022', demandDate: '2024-07-15', dueDate: '2024-07-15', amountTotal: 4000, amountPaid: 0, balance: 4000, status: 'Pending' },
    { id: 1788, student: 'Michael Lee', year: '2021-2022', demandDate: '2024-07-15', dueDate: '2024-07-15', amountTotal: 4100, amountPaid: 0, balance: 4100, status: 'Pending' },
    { id: 1789, student: 'Emily Davis', year: '2022-2023', demandDate: '2024-08-05', dueDate: '2024-08-05', amountTotal: 4200, amountPaid: 0, balance: 4200, status: 'Pending' },
    { id: 1790, student: 'David Brown', year: '2022-2023', demandDate: '2024-08-05', dueDate: '2024-08-05', amountTotal: 4300, amountPaid: 0, balance: 4300, status: 'Pending' },
    { id: 1791, student: 'Alice Green', year: '2023-2024', demandDate: '2024-09-01', dueDate: '2024-09-01', amountTotal: 4400, amountPaid: 0, balance: 4400, status: 'Pending' },
    { id: 1792, student: 'Chris White', year: '2023-2024', demandDate: '2024-09-01', dueDate: '2024-09-01', amountTotal: 4500, amountPaid: 0, balance: 4500, status: 'Pending' },
    { id: 1793, student: 'Olivia Black', year: '2024-2025', demandDate: '2024-09-25', dueDate: '2024-09-25', amountTotal: 4600, amountPaid: 0, balance: 4600, status: 'Pending' },
    { id: 1794, student: 'Ethan Hall', year: '2024-2025', demandDate: '2024-09-25', dueDate: '2024-09-25', amountTotal: 4700, amountPaid: 0, balance: 4700, status: 'Pending' },
    { id: 1795, student: 'Charlotte King', year: '2025-2026', demandDate: '2024-10-15', dueDate: '2024-10-15', amountTotal: 4800, amountPaid: 0, balance: 4800, status: 'Pending' },
    { id: 1796, student: 'James Carter', year: '2025-2026', demandDate: '2024-10-15', dueDate: '2024-10-15', amountTotal: 4900, amountPaid: 0, balance: 4900, status: 'Pending' },
    { id: 1797, student: 'Sophia Lee', year: '2026-2027', demandDate: '2024-11-20', dueDate: '2024-11-20', amountTotal: 5000, amountPaid: 0, balance: 5000, status: 'Pending' },
    { id: 1798, student: 'Jack Young', year: '2026-2027', demandDate: '2024-11-20', dueDate: '2024-11-20', amountTotal: 5100, amountPaid: 0, balance: 5100, status: 'Pending' },
    { id: 1798, student: 'Jack Young', year: '2026-2027', demandDate: '2024-11-20', dueDate: '2024-11-20', amountTotal: 5100, amountPaid: 0, balance: 5100, status: 'Pending' },
  ];

  const handleChange = (e) => {
    
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value
    }));
  };

  const handleClear = () => {
    setFilters({ invoiceId: '', student: '', rfid: '', email: '' });
  };

  const filteredInvoices = invoices.filter((invoice) => {
    return (
      (filters.invoiceId === '' || invoice.id.toString().includes(filters.invoiceId)) &&
      (filters.student === '' || invoice.student.toLowerCase().includes(filters.student.toLowerCase()))
    );
  });

  const totalPages = Math.ceil(filteredInvoices.length / invoicesPerPage);
  const currentInvoices = filteredInvoices.slice(
    (currentPage - 1) * invoicesPerPage,
    currentPage * invoicesPerPage
  );

  return (
    <div className="verification-main-wrapper my-4">
      <Container fluid className="verification-container-fluid">
        <div className="verification-header-section">
          <h1 className="verification-title-text">Verified Enquiries</h1>
          
        </div>
        <div className="d-flex flex-wrap gap-3 mb-2">
         <Form.Control
              type="text"
              placeholder="RFID ID"
              name="invoiceId"
              value={filters.invoiceId}
              onChange={handleChange}
              className="verification-filter-input-rfid "
            />
            <Form.Control
              type="text"
              placeholder="Filter by Student"
              name="student"
              value={filters.student}
              onChange={handleChange}
              className="verification-filter-input-student"
            />
            <Button onClick={handleClear} className="verification-export-btn custom-btn">Clear</Button>
          
        </div>

        

        {message && (
          <div className="verification-message-display">
            {message}
          </div>
        )}

        <div className="verification-table-header-row">
          <div className="verification-grid-layout">
            <div className="verification-header-cell">Sr No</div>
            <div className="verification-header-cell">RFID</div>
            <div className="verification-header-cell">First Name</div>
            <div className="verification-header-cell">Grade</div>
            <div className="verification-header-cell">Date 1</div>
            <div className="verification-header-cell">Date 2</div>
            <div className="verification-header-cell">Amount</div>
            <div className="verification-header-cell">Paid</div>
            <div className="verification-header-cell">Total</div>
            <div className="verification-header-cell verification-actions-header">
              <span className="verification-actions-text">Actions</span>
            </div>
          </div>
        </div>

        <div className="verification-data-rows-container">
          {currentInvoices.map((invoice, index) => (
            <div key={invoice.id} className="verification-single-row-card">
              <div className="verification-grid-layout">
                <div className="verification-data-cell">
                  {(currentPage - 1) * invoicesPerPage + index + 1}
                </div>
                <div className="verification-data-cell">{invoice.id}</div>
                <div className="verification-data-cell">{invoice.student}</div>
                <div className="verification-data-cell">{invoice.year}</div>
                <div className="verification-data-cell">{invoice.demandDate}</div>
                <div className="verification-data-cell">{invoice.dueDate}</div>
                <div className="verification-data-cell">${invoice.amountTotal}</div>
                <div className="verification-data-cell">${invoice.amountPaid}</div>
                <div className="verification-data-cell">${invoice.balance}</div>
                <div className="verification-data-cell verification-action-buttons-container gap-2">
                  <button
                    className="verification-action-icon-btn "
                    title="ViewInvoice"
                onClick={() => navigate("/ViewInvoice")}>
                    <FaSearch />
                  </button>
                  <button
                    className="verification-action-icon-btn"
                    title="SendInvoice"
               onClick={() => navigate("/SendInvoice")}>
                    <FaEdit />
                  </button>
                  <button
                    className="verification-action-icon-btn" 
                    title="Delete Invoice"
                    onClick={() => setMessage(`Delete Invoice ID: ${invoice.id}`)}
                  >
                    <FaTrashAlt />
                  </button>
                  
                </div>
              </div>
            </div>
          ))}
        </div>
           <div className="pending-invoices-pagination-text">
          Showing 1 - 15 of 15 items
        </div>
      </Container>
    </div>
  );
};

export default CollectRegistrationFee;
